export const PATIENT_LIST = 'patients';
export const PATIENT_LIST_RESULT = `${PATIENT_LIST}/result`;
export const PATIENT_LIST_CLEAR = `${PATIENT_LIST}/clear`;
export const PATIENT_LIST_QUERY = 'patient-list-query';

export const lOAD_PATIENTS = 'load-patients';
export const lOAD_PATIENTS_RESULT = `${lOAD_PATIENTS}/result`;
export const lOAD_PATIENTS_CLEAR = `${lOAD_PATIENTS}/clear`;

export const EVENT_LIST = 'events';
export const EVENT_LIST_RESULT = `${EVENT_LIST}/result`;
export const EVENT_LIST_ERROR = `${EVENT_LIST}/error`;

export const GET_DEVICES = 'get-devices';
export const GET_DEVICES_RESULT = `${GET_DEVICES}/result`;
export const GET_DEVICES_ERROR = `${GET_DEVICES}/error`;

export const GET_PATIENT_DEVICES = 'get-patient-devices';
export const GET_PATIENT_DEVICES_RESULT = `${GET_PATIENT_DEVICES}/result`;
export const GET_PATIENT_DEVICES_ERROR = `${GET_PATIENT_DEVICES}/error`;

export const GET_DEVICES_DETAILS = 'get-devices-details';
export const GET_DEVICES_DETAILS_RESULT = `${GET_DEVICES_DETAILS}/result`;
export const GET_DEVICES_DETAILS_ERROR = `${GET_DEVICES_DETAILS}/error`;

export const GET_CAP_DETAILS = 'get-cap-details';
export const GET_CAP_DETAILS_RESULT = `${GET_CAP_DETAILS}/result`;
export const GET_CAP_DETAILS_ERROR = `${GET_CAP_DETAILS}/error`;

export const TASK_HISTORY_LIST = 'task-history-list';
export const TASK_HISTORY_LIST_RESULT = `${TASK_HISTORY_LIST}/result`;
export const TASK_HISTORY_LIST_ERROR = `${TASK_HISTORY_LIST}/error`;
export const TASK_HISTORY_FILTER_OPTIONS = 'task-history-filter-options';
export const TASK_HISTORY_FILTER_OPTIONS_RESULT = `${TASK_HISTORY_FILTER_OPTIONS}/result`;

export const DOWNLOAD_TASK_HISTORY = 'download-task-history';
export const DOWNLOAD_TASK_HISTORY_RESULT = `${DOWNLOAD_TASK_HISTORY}/result`;
export const DOWNLOAD_TASK_HISTORY_ERROR = `${DOWNLOAD_TASK_HISTORY}/error`;

export const PATIENT_DETAILS = 'patient-details';
export const PATIENT_DETAILS_RESULT = `${PATIENT_DETAILS}/result`;
export const PATIENT_DETAILS_ERROR = `${PATIENT_DETAILS}/error`;
export const PATIENT_DETAILS_CLEAR = `${PATIENT_DETAILS}/clear`;

export const UPDATE_PRIMARY_CARE_PROVIDER = 'update-primary-care-provider';
export const UPDATE_PRIMARY_CARE_PROVIDER_RESULT = `${UPDATE_PRIMARY_CARE_PROVIDER}/result`;
export const UPDATE_PRIMARY_CARE_PROVIDER_ERROR = `${UPDATE_PRIMARY_CARE_PROVIDER}/error`;

export const UPDATE_REFERRING_PROVIDER = 'update-referring-provider';
export const UPDATE_REFERRING_PROVIDER_RESULT = `${UPDATE_REFERRING_PROVIDER}/result`;
export const UPDATE_REFERRING_PROVIDER_ERROR = `${UPDATE_REFERRING_PROVIDER}/error`;

export const PATIENT_DASHBOARD_INFO = 'patient-dashboard-info';
export const PATIENT_DASHBOARD_INFO_RESULT = `${PATIENT_DASHBOARD_INFO}/result`;
export const PATIENT_DASHBOARD_INFO_ERROR = `${PATIENT_DASHBOARD_INFO}/error`;

export const PATIENT_BILLABLE_TIME = 'patient-billable-time';
export const PATIENT_BILLABLE_TIME_RESULT = `${PATIENT_BILLABLE_TIME}/result`;
export const PATIENT_BILLABLE_TIME_ERROR = `${PATIENT_BILLABLE_TIME}/error`;

export const CLEAR_PATIENT_BILLABLE_TIME = 'clear-patient-billable-time';

export const POST_MANUAL_VITALS = 'post-manual-vitals';
export const POST_MANUAL_VITALS_RESULT = `${POST_MANUAL_VITALS}/result`;
export const POST_MANUAL_VITALS_ERROR = `${POST_MANUAL_VITALS}/error`;

export const ADD_MEDICINE = 'add-medicine';
export const ADD_MEDICINE_RESULT = `${ADD_MEDICINE}/result`;
export const ADD_MEDICINE_ERROR = `${ADD_MEDICINE}/error`;

export const ADD_PATIENT = 'add-patient';
export const ADD_PATIENT_RESULT = `${ADD_PATIENT}/result`;
export const ADD_PATIENT_ERROR = `${ADD_PATIENT}/error`;

export const EDIT_PATIENT = 'edit-patient';
export const EDIT_PATIENT_RESULT = `${EDIT_PATIENT}/result`;
export const EDIT_PATIENT_ERROR = `${EDIT_PATIENT}/error`;

export const GET_MEDICATIONS = 'get-medications';
export const GET_MEDICATIONS_RESULT = `${GET_MEDICATIONS}/result`;
export const GET_MEDICATIONS_ERROR = `${GET_MEDICATIONS}/error`;

export const SEARCH_MEDUCATION = 'search-meducation';
export const SEARCH_MEDUCATION_RESULT = `${SEARCH_MEDUCATION}/result`;
export const SEARCH_MEDUCATION_ERROR = `${SEARCH_MEDUCATION}/error`;
export const SEARCH_MEDUCATION_BATCH = 'search-meducation-batch';
export const SEARCH_MEDUCATION_BATCH_RESULT = `${SEARCH_MEDUCATION_BATCH}/result`;
export const SEARCH_MEDUCATION_BATCH_ERROR = `${SEARCH_MEDUCATION_BATCH}/error`;

export const START_TASK = 'start-task';
export const START_TASK_RESULT = `${START_TASK}/result`;
export const START_TASK_ERROR = `${START_TASK}/error`;

export const CONTINUE_TASK = 'continue-task';
export const CONTINUE_TASK_RESULT = `${CONTINUE_TASK}/result`;
export const CONTINUE_TASK_ERROR = `${CONTINUE_TASK}/error`;

export const END_TASK = 'end-task';
export const END_TASK_RESULT = `${END_TASK}/result`;
export const END_TASK_ERROR = `${END_TASK}/error`;

export const GET_TASKS_LIST = 'get-tasks-list';
export const GET_TASKS_LIST_RESULT = `${GET_TASKS_LIST}/result`;
export const GET_TASKS_LIST_ERROR = `${GET_TASKS_LIST}/error`;

export const GET_TIMER_TASKS_LIST = 'get-timer-tasks-list';
export const GET_TIMER_TASKS_LIST_RESULT = `${GET_TIMER_TASKS_LIST}/result`;
export const GET_TIMER_TASKS_LIST_ERROR = `${GET_TIMER_TASKS_LIST}/error`;

export const ENABLE_ORG_TASK = 'enable-org-task';
export const ENABLE_ORG_TASK_RESULT = `${ENABLE_ORG_TASK}/result`;
export const DISABLE_ORG_TASK = 'disable-org-task';
export const DISABLE_ORG_TASK_RESULT = `${DISABLE_ORG_TASK}/result`;

export const GET_TASKS_LIST_ALL = 'get-tasks-list-all';
export const GET_TASKS_LIST_ALL_RESULT = `${GET_TASKS_LIST_ALL}/result`;
export const GET_TASKS_LIST_ALL_ERROR = `${GET_TASKS_LIST_ALL}/error`;

export const GET_TASKS_LIST_ALL_ORGLESS = 'get-tasks-list-all-orgless';
export const GET_TASKS_LIST_ALL_ORGLESS_RESULT = `${GET_TASKS_LIST_ALL_ORGLESS}/result`;
export const GET_TASKS_LIST_ALL_ORGLESS_ERROR = `${GET_TASKS_LIST_ALL_ORGLESS}/error`;

export const CREATE_CUSTOM_TASK = 'create-custom-task';
export const CREATE_CUSTOM_TASK_RESULT = `${CREATE_CUSTOM_TASK}/result`;
export const CREATE_CUSTOM_TASK_ERROR = `${CREATE_CUSTOM_TASK}/error`;

export const UPDATE_GLOBAL_TASK_DEFAULTS = 'update-global-task-defaults';
export const UPDATE_GLOBAL_TASK_DEFAULTS_RESULT = `${UPDATE_GLOBAL_TASK_DEFAULTS}/result`;
export const UPDATE_GLOBAL_TASK_DEFAULTS_ERROR = `${UPDATE_GLOBAL_TASK_DEFAULTS}/error`;

export const UPDATE_CUSTOM_TASK = 'update-custom-task';
export const UPDATE_CUSTOM_TASK_RESULT = `${UPDATE_CUSTOM_TASK}/result`;
export const UPDATE_CUSTOM_TASK_ERROR = `${UPDATE_CUSTOM_TASK}/error`;

export const DELETE_CUSTOM_TASK = 'delete-custom-task';
export const DELETE_CUSTOM_TASK_RESULT = `${DELETE_CUSTOM_TASK}/result`;
export const DELETE_CUSTOM_TASK_ERROR = `${DELETE_CUSTOM_TASK}/error`;

export const DELETE_PATIENT = 'delete-patient';
export const DELETE_PATIENT_RESULT = `${DELETE_PATIENT}/result`;
export const DELETE_PATIENT_ERROR = `${DELETE_PATIENT}/error`;

export const DELETE_TASK_HISTORY = 'delete-task-history';
export const DELETE_TASK_HISTORY_RESULT = `${DELETE_TASK_HISTORY}/result`;
export const DELETE_TASK_HISTORY_ERROR = `${DELETE_TASK_HISTORY}/error`;

export const UPDATE_TIMER_TASK = 'update-timer-task';
export const UPDATE_TIMER_TASK_RESULT = `${UPDATE_TIMER_TASK}/result`;
export const UPDATE_TIMER_TASK_ERROR = `${UPDATE_TIMER_TASK}/error`;

export const ADD_TIMER_TASK = 'add-timer-task';
export const ADD_TIMER_TASK_RESULT = `${ADD_TIMER_TASK}/result`;
export const ADD_TIMER_TASK_ERROR = `${ADD_TIMER_TASK}/error`;

export const DELETE_TIMER_TASK = 'delete-timer-task';
export const DELETE_TIMER_TASK_RESULT = `${DELETE_TIMER_TASK}/result`;
export const DELETE_TIMER_TASK_ERROR = `${DELETE_TIMER_TASK}/error`;

export const SET_TIMER_DEFAULT_TASK = 'set-timer-default-task';
export const SET_TIMER_DEFAULT_TASK_RESULT = `${SET_TIMER_DEFAULT_TASK}/result`;
export const SET_TIMER_DEFAULT_TASK_ERROR = `${SET_TIMER_DEFAULT_TASK}/error`;

export const GET_TIMER_DEFAULT_TASK = 'get-timer-default-task';
export const GET_TIMER_DEFAULT_TASK_RESULT = `${GET_TIMER_DEFAULT_TASK}/result`;
export const GET_TIMER_DEFAULT_TASK_ERROR = `${GET_TIMER_DEFAULT_TASK}/error`;

export const BLOOD_PRESSURE = `blood_pressure`;
export const BATTERY = `battery`;
export const CONNECTION = `connection`;
export const WEIGHT = 'weight';
export const PULSE_OXIMETER = 'pulse_oximeter';
export const BLUETOOTH = 'bluetooth';
export const BLUETOOTH_CAP = 'Bluetooth cap';
export const WEIGHING_MACHINE = 'Weighing Machine';
export const BLOOD_PRESSURE_MONITOR = 'Blood Pressure Monitor';

export const CLEAR_DEVICE_DATA = 'clear-device-data';

export const GET_NOTES = 'get-notes';
export const GET_NOTES_RESULT = `${GET_NOTES}/result`;
export const GET_NOTES_ERROR = `${GET_NOTES}/error`;

export const SEARCH_FOR_NOTE_RECIPIENTS = 'search-for-note-recipients';
export const SEARCH_FOR_NOTE_RECIPIENTS_RESULT = `${SEARCH_FOR_NOTE_RECIPIENTS}/result`;
export const SEARCH_FOR_NOTE_RECIPIENTS_ERROR = `${SEARCH_FOR_NOTE_RECIPIENTS}/error`;

export const ADD_NOTE = 'add-note';
export const ADD_NOTE_RESULT = `${ADD_NOTE}/result`;
export const ADD_NOTE_ERROR = `${ADD_NOTE}/error`;

export const EDIT_NOTE = 'edit-note';
export const EDIT_NOTE_RESULT = `${EDIT_NOTE}/result`;
export const EDIT_NOTE_ERROR = `${EDIT_NOTE}/error`;

export const UPDATE_ACTION_STATUS = 'update-action-status';
export const UPDATE_ACTION_STATUS_RESULT = `${UPDATE_ACTION_STATUS}/result`;
export const UPDATE_ACTION_STATUS_ERROR = `${UPDATE_ACTION_STATUS}/error`;

export const GET_NOTE = 'get-note';
export const GET_NOTE_RESULT = `${GET_NOTE}/result`;
export const GET_NOTE_ERROR = `${GET_NOTE}/error`;

export const PATIENT_LIST_FOR_SUGGESTION = 'patients-for-suggestion';
export const PATIENT_LIST_FOR_SUGGESTION_RESULT = `${PATIENT_LIST_FOR_SUGGESTION}/result`;
export const PATIENT_LIST_FOR_SUGGESTION_CLEAR = `${PATIENT_LIST_FOR_SUGGESTION}/clear`;

export const GET_CONDITION_LIST = 'get-condition-list';
export const GET_CONDITION_LIST_RESULT = `${GET_CONDITION_LIST}/result`;
export const GET_CONDITION_LIST_ERROR = `${GET_CONDITION_LIST}/error`;

export const ENROLL_PATIENT = 'enroll-patient';
export const ENROLL_PATIENT_RESULT = `${ENROLL_PATIENT}/result`;
export const ENROLL_PATIENT_ERROR = `${ENROLL_PATIENT}/error`;

export const REGISTER_ENROLLMENT = 'register-enrollment';
export const REGISTER_ENROLLMENT_RESULT = `${REGISTER_ENROLLMENT}/result`;
export const REGISTER_ENROLLMENT_ERROR = `${REGISTER_ENROLLMENT}/error`;

export const ENROLL_ACCESS_ENROLLMENT = 'enroll-access-enrollment';
export const ENROLL_ACCESS_ENROLLMENT_RESULT = `${ENROLL_ACCESS_ENROLLMENT}/result`;
export const ENROLL_ACCESS_ENROLLMENT_ERROR = `${ENROLL_ACCESS_ENROLLMENT}/error`;

export const RESOLVE_PRIMARY_CARE_PROVIDER = 'resolve-primary-care-provider';
export const RESOLVE_PRIMARY_CARE_PROVIDER_RESULT = `${RESOLVE_PRIMARY_CARE_PROVIDER}/result`;
export const RESOLVE_PRIMARY_CARE_PROVIDER_ERROR = `${RESOLVE_PRIMARY_CARE_PROVIDER}/error`;

export const SEARCH_EXTERNAL_PROVIDERS = 'search-external-providers';
export const SEARCH_EXTERNAL_PROVIDERS_RESULT = `${SEARCH_EXTERNAL_PROVIDERS}/result`;
export const SEARCH_EXTERNAL_PROVIDERS_ERROR = `${SEARCH_EXTERNAL_PROVIDERS}/error`;

export const END_ENROLLMENT = 'end-enrollment';
export const END_ENROLLMENT_RESULT = `${END_ENROLLMENT}/result`;
export const END_ENROLLMENT_ERROR = `${END_ENROLLMENT}/error`;

export const UNREGISTER_ENROLLMENT = 'unregister-enrollment';
export const UNREGISTER_ENROLLMENT_RESULT = `${UNREGISTER_ENROLLMENT}/result`;
export const UNREGISTER_ENROLLMENT_ERROR = `${UNREGISTER_ENROLLMENT}/error`;

export const REASSIGN_CARE_PROVIDER = 'reassign-care-provider';
export const REASSIGN_CARE_PROVIDER_RESULT = `${REASSIGN_CARE_PROVIDER}/result`;
export const REASSIGN_CARE_PROVIDER_ERROR = `${REASSIGN_CARE_PROVIDER}/error`;

export const GET_READINGS = 'get-readings';
export const GET_READINGS_RESULT = `${GET_READINGS}/result`;
export const GET_READINGS_ERROR = `${GET_READINGS}/error`;

export const ARCHIVE_PATIENT = 'archive-patient';
export const ARCHIVE_PATIENT_RESULT = `${ARCHIVE_PATIENT}/result`;
export const ARCHIVE_PATIENT_ERROR = `${ARCHIVE_PATIENT}/error`;

export const GET_SCHEDULE = 'get-schedule';
export const GET_SCHEDULE_RESULT = `${GET_SCHEDULE}/result`;
export const GET_SCHEDULE_ERROR = `${GET_SCHEDULE}/error`;

export const GET_CAP_PLOT_DATA = 'get-cap-plot-data';
export const GET_CAP_PLOT_DATA_RESULT = `${GET_CAP_PLOT_DATA}/result`;
export const GET_CAP_PLOT_DATA_ERROR = `${GET_CAP_PLOT_DATA}/error`;

export const GET_CAPS_WITHOUT_SCHEDULE = 'get-caps-without-schedule';
export const GET_CAPS_WITHOUT_SCHEDULE_RESULT = `${GET_CAPS_WITHOUT_SCHEDULE}/result`;
export const GET_CAPS_WITHOUT_SCHEDULE_ERROR = `${GET_CAPS_WITHOUT_SCHEDULE}/error`;

export const SEND_WELCOME_MESSAGE = 'send-welcome-messages';
export const SEND_WELCOME_MESSAGE_RESULT = `${SEND_WELCOME_MESSAGE}/result`;
export const SEND_WELCOME_MESSAGE_ERROR = `${SEND_WELCOME_MESSAGE}/error`;

export const EDIT_WELCOME_MESSAGE = 'edit-welcome-messages';
export const EDIT_WELCOME_MESSAGE_RESULT = `${EDIT_WELCOME_MESSAGE}/result`;
export const EDIT_WELCOME_MESSAGE_ERROR = `${EDIT_WELCOME_MESSAGE}/error`;

export const GET_WELCOME_MESSAGE = 'get-welcome-message';
export const GET_WELCOME_MESSAGE_RESULT = `${GET_WELCOME_MESSAGE}/result`;
export const GET_WELCOME_MESSAGE_ERROR = `${GET_WELCOME_MESSAGE}/error`;

export const DOWNLOAD_NOTES_AND_ACTIONS = 'download-notes-and-actions';
export const DOWNLOAD_NOTES_AND_ACTIONS_RESULT = `${DOWNLOAD_NOTES_AND_ACTIONS}/result`;
export const DOWNLOAD_NOTES_AND_ACTIONS_ERROR = `${DOWNLOAD_NOTES_AND_ACTIONS}/error`;

export const DOWNLOAD_PATIENTS_EVENTS = 'download-patients-events';
export const DOWNLOAD_PATIENTS_EVENTS_RESULT = `${DOWNLOAD_PATIENTS_EVENTS}/result`;
export const DOWNLOAD_PATIENTS_EVENTS_ERROR = `${DOWNLOAD_PATIENTS_EVENTS}/error`;

export const GET_SCHEDULE_NOTIFICATIONS = 'get-scheule-notifications';
export const GET_SCHEDULE_NOTIFICATIONS_RESULT = `${GET_SCHEDULE_NOTIFICATIONS}/result`;
export const GET_SCHEDULE_NOTIFICATIONS_ERROR = `${GET_SCHEDULE_NOTIFICATIONS}/error`;

export const DOWNLOAD_KIT_DATA = 'download-kit-data';
export const DOWNLOAD_KIT_DATA_RESULT = `${DOWNLOAD_KIT_DATA}/result`;
export const DOWNLOAD_KIT_DATA_ERROR = `${DOWNLOAD_KIT_DATA}/error`;

export const DOWNLOAD_MONTHLY_SUMMARY = 'download-monthly-summary';
export const DOWNLOAD_MONTHLY_SUMMARY_RESULT = `${DOWNLOAD_MONTHLY_SUMMARY}/result`;
export const DOWNLOAD_MONTHLY_SUMMARY_ERROR = `${DOWNLOAD_MONTHLY_SUMMARY}/error`;

export const GET_AVERAGE_READINGS = 'get-average-readings';
export const GET_AVERAGE_READINGS_RESULT = `${GET_AVERAGE_READINGS}/result`;
export const GET_AVERAGE_READINGS_ERROR = `${GET_AVERAGE_READINGS}/error`;

export const INVITE_PATIENT_TO_PORTAL = 'invite-patient-to-portal';
export const INVITE_PATIENT_TO_PORTAL_RESULT = `${INVITE_PATIENT_TO_PORTAL}/result`;
export const INVITE_PATIENT_TO_PORTAL_ERROR = `${INVITE_PATIENT_TO_PORTAL}/error`;

export const GET_PATIENT_ADHERENCE = 'get-patient-adherence';
export const GET_PATIENT_ADHERENCE_RESULT = `${GET_PATIENT_ADHERENCE}/result`;
export const GET_PATIENT_ADHERENCE_ERROR = `${GET_PATIENT_ADHERENCE}/error`;

export const GET_UNBILLED_EVIDENCES = 'get-unbilled-evidences';
export const GET_UNBILLED_EVIDENCES_RESULT = `${GET_UNBILLED_EVIDENCES}/result`;
export const GET_UNBILLED_EVIDENCES_ERROR = `${GET_UNBILLED_EVIDENCES}/error`;

export const GET_PROVIDER_VISIT_SUMMARY = 'get-provider-visit-summary';
export const GET_PROVIDER_VISIT_SUMMARY_RESULT = `${GET_PROVIDER_VISIT_SUMMARY}/result`;
export const GET_PROVIDER_VISIT_SUMMARY_ERROR = `${GET_PROVIDER_VISIT_SUMMARY}/error`;

export const GET_CARE_PROVIDED_ORGANIZATIONS = 'get-care-provided-organizations';
export const GET_CARE_PROVIDED_ORGANIZATIONS_RESULT = `${GET_CARE_PROVIDED_ORGANIZATIONS}/result`;
export const GET_CARE_PROVIDED_ORGANIZATIONS_ERROR = `${GET_CARE_PROVIDED_ORGANIZATIONS}/error`;

export const SET_ORG_FILTER = 'set-org-filter';

export const GET_READINGS_SCHEDULES = 'get-readings-schedules';
export const GET_READINGS_SCHEDULES_RESULT = `${GET_READINGS_SCHEDULES}/result`;
export const GET_READINGS_SCHEDULES_ERROR = `${GET_READINGS_SCHEDULES}/error`;

export const CREATE_READINGS_SCHEDULE = 'create-readings-schedule';
export const CREATE_READINGS_SCHEDULE_RESULT = `${CREATE_READINGS_SCHEDULE}/result`;
export const CREATE_READINGS_SCHEDULE_ERROR = `${CREATE_READINGS_SCHEDULE}/error`;

export const EDIT_READINGS_SCHEDULE = 'edit-readings-schedule';
export const EDIT_READINGS_SCHEDULE_RESULT = `${EDIT_READINGS_SCHEDULE}/result`;
export const EDIT_READINGS_SCHEDULE_ERROR = `${EDIT_READINGS_SCHEDULE}/error`;

export const DELETE_READINGS_SCHEDULE = 'delete-readings-schedule';
export const DELETE_READINGS_SCHEDULE_RESULT = `${DELETE_READINGS_SCHEDULE}/result`;
export const DELETE_READINGS_SCHEDULE_ERROR = `${DELETE_READINGS_SCHEDULE}/error`;

export const PATIENT_ELIGIBILITY_INFO = 'patient-eligibility-info';
export const PATIENT_ELIGIBILITY_INFO_RESULT = `${PATIENT_ELIGIBILITY_INFO}/result`;
export const PATIENT_ELIGIBILITY_INFO_ERROR = `${PATIENT_ELIGIBILITY_INFO}/error`;

export const TRIGGER_ELIGIBILITY_CHECK = 'trigger-eligibility-check';
export const TRIGGER_ELIGIBILITY_CHECK_RESULT = `${TRIGGER_ELIGIBILITY_CHECK}/result`;
export const TRIGGER_ELIGIBILITY_CHECK_ERROR = `${TRIGGER_ELIGIBILITY_CHECK}/error`;

export const REFRESH_ELIGIBILITY_RESULTS = 'refresh-eligibility-results';
export const REFRESH_ELIGIBILITY_RESULTS_RESULT = `${REFRESH_ELIGIBILITY_RESULTS}/result`;
export const REFRESH_ELIGIBILITY_RESULTS_ERROR = `${REFRESH_ELIGIBILITY_RESULTS}/error`;

export const GET_PATIENT_STATUS_COUNTS = 'get-patient-status-counts';
export const GET_PATIENT_STATUS_COUNTS_RESULT = `${GET_PATIENT_STATUS_COUNTS}/result`;
export const GET_PATIENT_STATUS_COUNTS_ERROR = `${GET_PATIENT_STATUS_COUNTS}/error`;

export const GET_PATIENT_PROVIDER_OPTIONS = 'get-patient-provider-options';
export const GET_PATIENT_PROVIDER_OPTIONS_RESULT = `${GET_PATIENT_PROVIDER_OPTIONS}/result`;
export const GET_PATIENT_PROVIDER_OPTIONS_ERROR = `${GET_PATIENT_PROVIDER_OPTIONS}/error`;

export const MOVE_TO_NOT_ENROLLED = 'move-to-not-enrolled';
export const MOVE_TO_NOT_ENROLLED_RESULT = `${MOVE_TO_NOT_ENROLLED}/result`;
export const MOVE_TO_NOT_ENROLLED_ERROR = `${MOVE_TO_NOT_ENROLLED}/error`;

export const CLEAR_NOT_ENROLLED_STATUS = 'clear-not-enrolled-status';
export const CLEAR_NOT_ENROLLED_STATUS_RESULT = `${CLEAR_NOT_ENROLLED_STATUS}/result`;
export const CLEAR_NOT_ENROLLED_STATUS_ERROR = `${CLEAR_NOT_ENROLLED_STATUS}/error`;

export const GET_PATIENT_TEXT_OPT_OUT_STATUS = 'get-patient-text-opt-out-status';
export const GET_PATIENT_TEXT_OPT_OUT_STATUS_RESULT = `${GET_PATIENT_TEXT_OPT_OUT_STATUS}/result`;
export const GET_PATIENT_TEXT_OPT_OUT_STATUS_ERROR = `${GET_PATIENT_TEXT_OPT_OUT_STATUS}/error`;

export const UPDATE_PATIENT_TEXT_OPT_OUT_STATUS = 'update-patient-text-opt-out-status';
export const UPDATE_PATIENT_TEXT_OPT_OUT_STATUS_RESULT = `${UPDATE_PATIENT_TEXT_OPT_OUT_STATUS}/result`;
export const UPDATE_PATIENT_TEXT_OPT_OUT_STATUS_ERROR = `${UPDATE_PATIENT_TEXT_OPT_OUT_STATUS}/error`;

export const GET_ENROLLMENT_STATUS_HISTORY = 'get-enrollment-status-history';
export const GET_ENROLLMENT_STATUS_HISTORY_RESULT = `${GET_ENROLLMENT_STATUS_HISTORY}/result`;
export const GET_ENROLLMENT_STATUS_HISTORY_ERROR = `${GET_ENROLLMENT_STATUS_HISTORY}/error`;

export const GET_ANNOTATIONS = 'get-annotations';
export const GET_ANNOTATIONS_RESULT = `${GET_ANNOTATIONS}/result`;
export const GET_ANNOTATIONS_ERROR = `${GET_ANNOTATIONS}/error`;

export const ADD_ANNOTATION = 'add-annotation';
export const ADD_ANNOTATION_RESULT = `${ADD_ANNOTATION}/result`;
export const ADD_ANNOTATION_ERROR = `${ADD_ANNOTATION}/error`;

export const EDIT_ANNOTATION = 'edit-annotation';
export const EDIT_ANNOTATION_RESULT = `${EDIT_ANNOTATION}/result`;
export const EDIT_ANNOTATION_ERROR = `${EDIT_ANNOTATION}/error`;

export const DELETE_ANNOTATION = 'delete-annotation';
export const DELETE_ANNOTATION_RESULT = `${DELETE_ANNOTATION}/result`;
export const DELETE_ANNOTATION_ERROR = `${DELETE_ANNOTATION}/error`;

export const GET_ANNOTATION = 'get-annotation';
export const GET_ANNOTATION_RESULT = `${GET_ANNOTATION}/result`;
export const GET_ANNOTATION_ERROR = `${GET_ANNOTATION}/error`;

export const GET_PATIENT_MONITORING_REPORT = 'get-patient-monitoring-report';
export const GET_PATIENT_MONITORING_REPORT_RESULT = `${GET_PATIENT_MONITORING_REPORT}/result`;
export const GET_PATIENT_MONITORING_REPORT_ERROR = `${GET_PATIENT_MONITORING_REPORT}/error`;
